export const Token = {
    USERNAME: 'us_id',
    SESSION: 'us_ss_id',
    LIMITS: 'us_tb_lmt',
    BET_COIN: 'bt_con',
    LOBY_NOTICE: 'lb_ntce',
    DESK_NOTICE: 'dk_ntce',
    DESK_LIMIT: 'dsk_lmt',
    CHIPS_VALUES: 'chips_values',
    SOUND: 'config_sound',
    MULTIBET_DESK: 'multi_desks_bet',
    CURRENT_CHIP_INDEX: 'c_cph_idx',
    CUSTOM_CHIP_VALUE: 'c_cph_vl',
    LANG: 'lang',
    LINE: 'ap_line',
    LINE_STR: 'ap_line_str',
    MEMEBER_ID: 'a_net_01',
    USER_INFO: 'a_net_02',
    RED_PACKETS: 'b_net_01',
    SHOW_RED_PACKETS: 'b_net_02'
}

/**
 * API ACT params
 */
export const ACT = {
    LOGIN: 1,
    TRIAL: 11,
    LOG_OUT: 17,
    MULTIPLE_DESK_INFO: 2,
    GET_NOTICE_AND_LIMIT: 9,
    SINGLE_DESK_INFO: 3,
    CARD_INFO: 10,
    DO_DT_BET: 7,
    DO_BAC_BET: 6,
    CHANGE_PASS: 12,
    GET_LOG: 13,
    GET_LOG_DETAILS: 15,
    MULTIPLE_BET_DESK_INFO: 18,
    VIDEO_INFOS: 28
}

export const Color = {
    RED: 1,
    BLUE: 2
}

/**
 * Determin the game type
 */
export const GAME_TYPE = {
    BACCARAT: 'G002',
    DRAGON_TIGER: 'G003'
}

/**
 * BET TYPE
 * Determin the type of Bet
 */
export const BET_TYPE = {
    BANKER: 0,
    PLAYER: 1,
    BC_TIE: 2,
    DT_TIE: 3,
    DRAGON: 4,
    TIGER: 5,
    PLAYER_PAIR: 6,
    BANKER_PAIR: 7,
    BANKER_SUPER6: 8,
    SUPER6: 9,
    BEAR_8: 10,
    SMALL_TIGER: 11,
    BIG_TIGER: 12,
    DRAGON_7: 13
}

/**
 * GameState Of a Desk
 */
export const GameRoundState = {
    CLOSED: 1,
    END_OF_ROUND: 4
}

/**
 * Game Result
 */
export const RESULT = {
    RED: 1,
    BLUE: 3,
    GREEN: 2,
    DRAGON: 4,
    TIGER: 6,
    DRAGON_TIGER_TIE: 7,
    SUPER6: 8
}

export enum EventBuss {
    SHOW_POP_ALERT = 'SHOW_POP_ALERT',
    RELOAD_MAP = 'RELOAD_MAP',
    ORIENTATION_CHANGE = 'ORIENTATION_CHANGE',
    ON_ADD_TO_HOME_PAGE = 'ON_ADD_TO_HOME_PAGE',
    TOAST_MESSAGE = 'TOAST_MESSAGE',
    SHOW_NUMERIC_KEYBOARD = 'SHOW_NUMERIC_KEYBOARD',
    SOCKET_CONNECT = 'SOCKET_CONNECT',
    SOCKET_CLOSE = 'SOCKET_CLOSE',
    SOCKET_MESSAGE = 'SOCKET_MESSAGE',
    SOCKET_RECONNECTED = 'SOCKET_RECONNECTED',
    SOCKET_RECONNECT_FAILED = 'SOCKET_RECONNECT_FAILED',
    SESSION_EXPIRED = 'SESSION_EXPIRED',
    TOGGLE_SMODE = 'TOGGLE_SMODE',
    LOCKED_SMODE = 'LOCKED_SMODE',
    LOG_OUT = 'LOG_OUT',
    PAGE_ON_VISIBLE = 'PAGE_ON_VISIBLE',
    BET_SUCCESS = 'BET_SUCCESS',
    UPDATE_NOTICE_KEY = 'UPDATE_NOTICE_KEY'
}

export enum SOCKET_MESSAGE {
    NEW_GAME = 'NEWGAME',
    USER_OUT = 'USER-OUT',
    USER_OUT_BY = 'USER-OUT-BY',
    END_GAME = 'ENDGAME',
    STOP_GAME = 'STOPGAME',
    GUNNER_VERIFY = 'GUNNER-VERIFY',
    SERVER_PONG = 'SERVER-PONG',
    CHANGE_LIMIT = 'CHANGE-LIMIT',
    BET = 'BET',
    GUNNER_BET = 'GUNNERBET',
    GUNNER_GIVEFREE = 'GUNNER-GIVEFEE',
    NEW_SHOE = 'NEWSHOE',
    CANCEL_GAME = 'CANCELGAME',
    MEMBER_PLAY = 'MEMBER-PLAY',
    MEMBER_AMOUNT = 'MEMBERAMOUNT',
    WS_EXPIRED = 'TOKEN-EXPIRED',
    TABLE_VISIT_STATUS = 'TABLE-VISIT-STATUS',
    STOP_BET = 'STOPBET',
    RED = 'RED'
}

/**
 * Determine the bet error
 */
export enum BetError {
    TIE_MAX_LIMIT = '超出和最大限红',
    BALANCE_SHORT = '余额不足',
    BELOW_MINIMUM = '小于最低限红',
    ABOVE_PAIR_LIMIT = '超出对子最大限红',
    SUPER6_ABOVE_LIMIT = '超出超级6最大限红',
    PALYER_BANKER_ABOVE_LIMIT = '超出庄闲最大限红',
    DRAGON_TIGER_ABOVE_LIMIT = '超出虎龙最大限红',
    ABOVE_MAXIMUM = '超过最大限红',
    SUPER6_TIGER_CONFLICT = '大小老虎和Super6不可同时下注',
    BET_OK = 'OK',
    UNKNOWN_ERROR = 'Unknown Error',
    NO_CHIPS_SELECTED = '请先选择筹码再投注'
}

// /**
//  * Determine the bet error
//  */
// export enum BetError {
//     TIE_MAX_LIMIT = 'TIE_MAX_LIMIT',
//     BALANCE_SHORT = 'BALANCE_SHORT',
//     BELOW_MINIMUM = 'BELOW_MINIMUM',
//     ABOVE_PAIR_LIMIT = 'ABOVE_PAIR_LIMIT',
//     SUPER6_ABOVE_LIMIT = 'SUPER6_ABOVE_LIMIT',
//     PALYER_BANKER_ABOVE_LIMIT = 'PALYER_BANKER_ABOVE_LIMIT',
//     DRAGON_TIGER_ABOVE_LIMIT = 'DRAGON_TIGER_ABOVE_LIMIT',
//     ABOVE_MAXIMUM = 'ABOVE_MAXIMUM',
//     BET_OK = 'OK',
//     UNKNOWN_ERROR = 'Unknown Error',
//     NO_CHIPS_SELECTED = 'NO_CHIPS_SELECTED'
// }

export const Lang = ['en', 'kor', 'zh']

type GoodRoadEntry = {
    color: number
    type: number
    names: Record<string, string>
}

export const GOOD_ROAD: Readonly<Record<number, GoodRoadEntry>> = Object.freeze(
    {
        1: {
            color: 0,
            type: 0,
            names: { G002: '长庄', G003: '长龙' }
        },
        2: {
            color: 1,
            type: 0,
            names: { G002: '长闲', G003: '长虎' }
        },
        3: {
            color: -1,
            type: 3,
            names: { G002: '大路单跳', G003: '大路单跳' }
        },
        4: {
            color: 0,
            type: 1,
            names: { G002: '一庄两闲', G003: '一龙两虎' }
        },
        5: {
            color: 1,
            type: 1,
            names: { G002: '一闲两庄', G003: '一虎两龙' }
        },
        6: {
            color: -1,
            type: 4,
            names: { G002: '长路转单跳', G003: '长路转单跳' }
        },
        7: {
            color: 0,
            type: 5,
            names: { G002: '逢庄跳', G003: '逢龙跳' }
        },
        8: {
            color: 1,
            type: 5,
            names: { G002: '逢闲跳', G003: '逢虎跳' }
        },
        9: {
            color: 0,
            type: 6,
            names: { G002: '逢庄连', G003: '逢龙连' }
        },
        10: {
            color: 1,
            type: 6,
            names: { G002: '逢闲连', G003: '逢虎连' }
        }
    }
)

export function getGoodRoadName(
    id: number,
    gameTypeNo: string = GAME_TYPE.BACCARAT
): string {
    const road = GOOD_ROAD[id]
    if (!road) return ''
    return road.names[gameTypeNo] || road.names[GAME_TYPE.BACCARAT] || ''
}
